export const prepareDataAPI = (data, state) => {

  // Empty tags array
  const tags = [];

  // Empty related applicant
  let relatedApplicant = '';

  // Empty related owner
  let previousOwnerState = [];

  Object.keys(data).forEach(function(key) {
    // make single item arrays ['true'] to a boolean
    if (data[key].length === 1 && Array.isArray(data[key])) {
      if ( data[key][0] === 'true' || data[key][0] === 'false') {
        data[key] = JSON.parse(data[key][0]);
      }
    }
    
    // delete empty arrays from data
    if (data[key].length === 0 && Array.isArray(data[key])) {
      delete data[key] 
    }

    // If abn is found, remove white spaces
    if (key === 'primaryContact' || key === 'applicant' || key === 'ownersCorpManagerDetails' || key === 'owners') {
      if ( key === 'owners') {
        for(var y = 0; y < data[key].length; y++) {
          if (data[key][y].abn) {
            data[key][y].abn = data[key][y].abn.replace(/\s/g,'');
          }
        }
      } else if (data[key].abn) {
        data[key].abn = data[key].abn.replace(/\s/g,'');
      }
    }
    
    // remove body corp details if common prop is set to false or empty
    if (key === 'ownersCorpManagerDetails' && data['isCommonPropertyInvolved'] !== "true") {
      delete data[key] 
    }

    // remove preapp if common preapp is set to false or empty
    if (key === 'preApplicationEventNumber' && data['preApplicationDiscussion'] !== "true") {
      delete data[key] 
    }

    // Populate tags array with cateogires from workCategories property
    if (key === 'workCategories') {
      for(var i = 0; i < data[key].length; i++) {
        const tag = data[key][i].category;
        if(!tags.includes(tag)) {
          tags.push(data[key][i].category);
        }
      }
    }

    // add user relationships to payload
    // remove user data if relationship match is found

    // applicant
    if (key === 'applicant') {
      if (data['sameAsPrimaryContact'] && data['sameAsPrimaryContact'][0] === "true") {
        delete data[key]
        relatedApplicant = {
          type: 'applicantPrimaryContactReference',
          abn: ''
        };
      } else {
        relatedApplicant = {
          type: 'applicantUser',
          abn: '',
          ...data[key]
        };
      }
    }
    
    // owners
    if (key === 'owners') {
      for(var j = 0; j < data[key].length; j++) {
        previousOwnerState.push({
          type: 'ownerUser',
          ...data[key][j]
        })
      }

      if (data['sameAsPrimaryContactApplicant'] === 'primaryContact') {
        // delete data[key][0]
        previousOwnerState[0] = {
          type: 'ownerPrimaryContactReference'
        }
      }

      if (data['sameAsPrimaryContactApplicant'] === 'applicant') {
        // delete data[key][0]
        previousOwnerState[0] = {
          type: 'ownerApplicantReference'
        }
      }
    }

    // estimatedCostofWorks
    if (key === 'estimatedCostOfWorks') {
      data[key] = +data[key]
    }

    // paymentReceipts
    if (key === 'paymentReceipts') {
      const cleanCurrency = data[key][0].amountPaid.replace(/[$,]/g , '');
      data[key][0].amountPaid = +cleanCurrency
    }
  });

  const newData = Object.assign({}, data, {
    applicant: relatedApplicant,
    owners: previousOwnerState,
    attachments: state.service.attachments.filter(attachment => attachment.transactionID),
    tags: tags,
    feeExemptionFlag: data.feeWaiverOrExemption === 'exemption' ? true : undefined,
    feeWaiver: data.feeWaiverOrExemption === 'waiver' ? data.feeWaiver : undefined,
    feePayable: data.feePayable ? parseFloat(data.feePayable) : undefined,
    paymentReceipts: data.paymentReceipts && data.paymentReceipts[0].amountPaid && data.paymentReceipts[0].receiptDate && ((data.paymentReceipts[0].type === "bpay" && data.paymentReceipts[0].bankName && data.paymentReceipts[0].receiptNumber) || (data.paymentReceipts[0].type === "ausPost" && data.paymentReceipts[0].paymentMethod && data.paymentReceipts[0].uniqueSequenceNumber)) ? data.paymentReceipts : undefined
  });

  // Remove empty keys
  function isEmpty(s) {
    return s === undefined || s === null || s.length === 0;
  };

  function iterAll(object) {
    Object.keys(object).forEach(function (k) {
      if (object[k] && typeof object[k] === 'object') {
        iterAll(object[k]);
        return;
      }
      
      if (isEmpty(object[k])) {
        delete object[k];
      }
      
      return;
    })
  };

  iterAll(newData);

  return newData;
}

export const prepareDraftDataAPI = (data, id, attachments) => { 
  // attach files from state to redux form state - only the ones with transactionID
  const newData = {
    id: id || null,
    jsonPayload: data,
    attachmentUris: (attachments.length) ? attachments
                    .filter(attachment => attachment.transactionID)
                    .map(function(attachment) { return attachment["attachmentURI"]; }) : null
  };
    
  return newData
}

export const removeUrlParameters = array => {
  let urlQueryParameters = window.location.search;

  if (!array.length) {
    return urlQueryParameters;
  }

  const removeUrlParameters = array.map(key => {
    if (urlQueryParameters.includes(key)) {
      const regExp = new RegExp(
        `&${key}=([a-z0-9-!%20;]+)`,
        "i"
      );
      urlQueryParameters = urlQueryParameters.replace(regExp, ``);
    }

    return urlQueryParameters;
  });
  return removeUrlParameters.pop();
};

export const getUrlParameterByKey = key => {
  const urlQueryParameters = window.location.search;
  const regExp = !key ?
    new RegExp("[a-z0-9-!=+]+", "ig") :
    new RegExp(`${key}=([a-z0-9-!+%20+@.;]+)`, "i");

  if (!key) {
    const objectOfParameters = urlQueryParameters
      .match(regExp)
      .reduce((acc, cur) => {
        const [key, value] = cur.split("=");
        return {
          ...acc,
          [key]: value
        };
      }, {});
    return objectOfParameters;
  }
  if (urlQueryParameters.includes(key) && urlQueryParameters.match(regExp)) {
    return urlQueryParameters.match(regExp)[1].replace(new RegExp('%20', 'g'), ' ');
  }

  return null;
};

export const setUrlParameter = (key, val, remove) => {
  const urlQueryParameters = remove ? remove : window.location.search;
  if (!key || !val) {
    return urlQueryParameters;
  }
  if (urlQueryParameters.includes(key)) {
    const regExp = new RegExp(`${key}=([a-z0-9-!%20;]+)|${key}=|${key}`, "i");
    return urlQueryParameters.replace(regExp, `${key}=${val}`);
  }

  return urlQueryParameters ?
    `${urlQueryParameters}&${key}=${val}` :
    urlQueryParameters;
};


export const leaf = (obj,path) => {
  path=path.split('.');
  var res=obj;
  for (var i=0;i<path.length;i++) res=res[path[i]];
  return res;
}

export const fileUploaded = (attachments) => {
  return attachments.find(attachment => { return attachment.isUploading || attachment.transactionID })
}

export const getFeeQuote = (data) => {

  const feeData = Object.assign({}, {
    "workType": "Permit-Application",
    "source": "Heritage Online Application",
    "questionnaire": data.feeQuestionnaire
  });
    
  return feeData
}